import { C } from '../../theme.js';
import { Code, FieldLabel, TextInput } from '../../components/Primitives.jsx';
import { ColSelect } from '../shared/ColSelect.jsx';

export function RegexExtractInspector({ step, onChange }) {
  const c = step.config || {};
  const u = (patch) => onChange({ ...step, config: { ...c, ...patch } });
  return (
    <div>
      <FieldLabel>Source column</FieldLabel>
      <ColSelect value={c.column} onChange={(v) => u({ column: v })} />
      <FieldLabel hint="First capture group becomes the value">Regex pattern</FieldLabel>
      <TextInput mono value={c.pattern} onChange={(v) => u({ pattern: v })} placeholder="@([^.]+)\\." />
      <FieldLabel>Output column</FieldLabel>
      <TextInput mono value={c.target} onChange={(v) => u({ target: v })} placeholder={`${c.column || 'email'}_extract`} />
      <FieldLabel>Common patterns</FieldLabel>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
        {[
          { label: 'Email domain', pat: '@(.+)$' },
          { label: 'Top-level domain', pat: '\\.([a-z]+)$' },
          { label: 'Numbers', pat: '(\\d+)' },
          { label: 'First word', pat: '^(\\w+)' },
        ].map(p => (
          <button key={p.label} onClick={() => u({ pattern: p.pat })}
            style={{
              fontFamily: 'inherit', cursor: 'pointer', textAlign: 'left',
              background: C.input, color: C.fg3,
              border: `1px solid ${C.border}`, borderRadius: 6,
              padding: '5px 9px', fontSize: '.74rem', display: 'flex', gap: 10,
            }}>
            <span style={{ color: C.fg2, flex: '0 0 110px', fontWeight: 600 }}>{p.label}</span>
            <Code style={{ background: 'transparent', padding: 0 }}>{p.pat}</Code>
          </button>
        ))}
      </div>
    </div>
  );
}
